import { Loader2, X } from 'lucide-react';
import { Button } from '@/ui/button';
import { Input } from '@/ui/input';
import type { ApiKey } from '@/services/api-key';

interface ProfileCenterApiKeyEditModalProps {
  isOpen: boolean;
  editingKey: ApiKey | null;
  editName: string;
  setEditName: (value: string) => void;
  updating: boolean;
  onClose: () => void;
  onUpdate: () => void;
}

export function ProfileCenterApiKeyEditModal({
  isOpen,
  editingKey,
  editName,
  setEditName,
  updating,
  onClose,
  onUpdate,
}: ProfileCenterApiKeyEditModalProps) {
  if (!isOpen || !editingKey) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 px-4">
      <div
        className="w-[520px] max-w-[90vw] rounded-lg bg-white shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-5">
          <h2 className="text-lg font-medium text-gray-900">编辑 API Key</h2>
          <button
            onClick={onClose}
            className="h-6 w-6 text-gray-400 transition-colors hover:text-gray-600"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              API Key 名称 <span className="text-red-500">*</span>
            </label>
            <Input
              type="text"
              value={editName}
              onChange={(event) => setEditName(event.target.value)}
              placeholder="请输入 API Key 名称"
              maxLength={50}
            />
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 border-t border-gray-100 px-6 py-4">
          <Button variant="outline" className="h-[38px] w-20" onClick={onClose}>
            取消
          </Button>
          <Button
            className="h-[38px] w-20 text-white"
            style={{
              background: 'linear-gradient(135deg, #7bb8ff 0%, #3F3663 100%)',
            }}
            onClick={onUpdate}
            disabled={updating || !editName.trim()}
          >
            {updating ? <Loader2 className="h-4 w-4 animate-spin" /> : '保存'}
          </Button>
        </div>
      </div>
    </div>
  );
}
